"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayAnnualCarDetailsWidget = void 0;
var React = require("react");
var moment = require("moment");
var commonFunctions_1 = require("../../../commonFunctions");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var DisplayAnnualCarDetailsWidget = exports.DisplayAnnualCarDetailsWidget = /** @class */ (function (_super) {
    __extends(DisplayAnnualCarDetailsWidget, _super);
    function DisplayAnnualCarDetailsWidget(props) {
        var _this = this;
        var _a, _b;
        _this = _super.call(this, props) || this;
        _this.renderCarDetails = function () {
            var car = _this.props.interaction.vehicles[_this.vehicleIndex];
            var purchaseDate = car.purchaseDate ? moment(car.purchaseDate).format("MMM YYYY") : null;
            var vehicleFound = _this.props.interaction.uistate.vehicleFound;
            var carMake = car.make !== null;
            var carModel = car.model !== null;
            var carRegistrationNumber = car.registrationNumber !== null;
            var vehicleNotYetRegistered = (!carMake || !carModel || !carRegistrationNumber) || ((typeof vehicleFound === "boolean") && !vehicleFound);
            var engineSize = (0, commonFunctions_1.getVehicleEngineSize)(car);
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "display-car-details" },
                    React.createElement("div", { className: "panel-preview-area mb-3" },
                        React.createElement("img", { className: "icon-lg car-icon", alt: "Vehicle icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/wolf-car-icon.png"), tabIndex: 0, "aria-label": "Vehicle icon" }),
                        car.make && car.model && React.createElement("h2", null,
                            car.make,
                            ", ",
                            car.model),
                        car.registrationNumber ?
                            React.createElement("div", { className: "number-plate-preview" }, car.registrationNumber)
                            :
                                _this.renderBannerOrInput()),
                    car.lvVehicleData && car.year && car.transmission && car.fuelType ?
                        React.createElement("div", { className: "car-details" },
                            engineSize &&
                                React.createElement("p", { className: "car-detail" },
                                    (0, commonFunctions_1.getVehicleEngineSize)(car),
                                    "cc"),
                            React.createElement("p", { className: "car-detail" },
                                (0, commonFunctions_1.getVehicleNumberOfDoors)(car),
                                " dr"),
                            React.createElement("p", { className: "car-detail" },
                                "Manufactured in ",
                                car.year),
                            purchaseDate && React.createElement("p", { className: "car-detail" },
                                "Purchased in ",
                                purchaseDate),
                            React.createElement("p", { className: "car-detail" }, _this.resolveLookupValue("vehicleTransmission", car.transmission)),
                            React.createElement("p", { className: "car-detail" }, _this.resolveLookupValue("vehicleFuelType", (0, commonFunctions_1.getInteractionVehicleFuelType)(car.fuelType, car.fuelTypeFull))))
                        :
                            React.createElement(React.Fragment, null, vehicleNotYetRegistered &&
                                React.createElement("div", { className: "info-button-panel d-flex banner" },
                                    React.createElement("img", { className: "d-block mx-3", src: "/".concat(services_1.resourcesHelper.THEME, "/img/alert-grey-blue.svg"), alt: "warning-sign" }),
                                    React.createElement("div", null,
                                        "We can't find your car. ",
                                        car.registrationNumber,
                                        " is NOT yet registered. Please enter your car details manually.")))),
                _this.getSetting("showButton", false) && _this.renderVehicleDetailsIsCorrectQuestion()));
        };
        _this.renderBannerOrInput = function () {
            return !_this.state.showVRNInput ?
                React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "link-edit text-center" },
                        React.createElement("button", { className: "btn-link mx-auto", onClick: _this.setShowVRNInput }, "Add registration number")),
                    React.createElement("div", { className: "info-button-panel font-weight-light d-flex missing-registration-number banner", role: "alert" },
                        React.createElement("img", { className: "d-block mx-3", src: "/".concat(services_1.resourcesHelper.THEME, "/img/alert-grey-blue.svg"), alt: "warning-sign" }),
                        React.createElement("div", null, "You'll need to provide your car registration number before buying your policy")))
                :
                    React.createElement("div", { className: "link-edit text-center" },
                        React.createElement("div", { className: "col-md-7 d-flex p-0 vrn-text-box" },
                            React.createElement("div", { className: "vrn-text-box__country-code-wrapper" },
                                React.createElement("span", { className: "vrn-text-box__country-code" }, "GB")),
                            React.createElement("input", { onInput: _this.handleVRNInput, onFocus: _this.executeNativeEvent, onClick: _this.executeNativeEvent, value: _this.state.vrn, type: "text", id: "registrationNumber", maxLength: 7, className: "form-control vrn-input-field ".concat(_this.state.isVRNValid ? "" : "is-invalid"), "aria-label": _this.props.question.label })),
                        !_this.state.isVRNValid &&
                            React.createElement("p", { className: "incorrect-vrn-warning" },
                                React.createElement("span", { className: "error-icon" }, "\u2716"),
                                " Please enter your car registration number"));
        };
        _this.renderVehicleDetailsIsCorrectQuestion = function () {
            var radioButtonName = _this.getSetting("radioButtonName", "");
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "display-annual-car-details-questions-container" },
                    React.createElement("div", { className: "media pt-3" },
                        React.createElement("div", { className: "media-body" },
                            React.createElement("label", null,
                                React.createElement("b", null, "Are the above vehicle details correct?"),
                                "\u00A0",
                                React.createElement("span", null,
                                    "If your vehicle details are not right, please select\u00A0",
                                    React.createElement("b", null, "No"),
                                    "\u00A0and you can change any of the details.")))),
                    React.createElement("div", { className: "input-group margin-top-14", role: "group" },
                        React.createElement("div", { className: "custom-control custom-radio" },
                            React.createElement("input", { className: "custom-control-input", id: "".concat(radioButtonName, "-true"), name: radioButtonName, type: "radio", value: "true", checked: _this.state.vehicleDetailsSetCorrectButtonState, onChange: _this.handleOnChangeEvent }),
                            React.createElement("label", { className: "custom-control-label", htmlFor: "".concat(radioButtonName, "-true") }, "Yes")),
                        React.createElement("div", { className: "custom-control custom-radio" },
                            React.createElement("input", { className: "custom-control-input", id: "".concat(radioButtonName, "-false"), name: radioButtonName, type: "radio", value: "false", checked: _this.state.vehicleDetailsSetCorrectButtonState === false, onChange: _this.handleOnChangeEvent }),
                            React.createElement("label", { className: "custom-control-label", htmlFor: "".concat(radioButtonName, "-false") }, "No"))))));
        };
        _this.navigateToEditCarDetailsPage = function () {
            _this.props.engine.navigate(_this.getSetting("navigateToPage", undefined), false);
        };
        _this.vehicleIndex = _this.getSetting("vehicleIndex", undefined);
        _this.vrnInputRedirect = _this.getSetting("vrnPageRedirect", undefined);
        _this.vehicleIndex = _this.vehicleIndex ? _this.vehicleIndex : 0;
        _this.vrnInputRedirect = _this.vrnInputRedirect ? _this.vrnInputRedirect : "numberPlateScan";
        var car = _this.props.interaction.vehicles[_this.vehicleIndex];
        _this.state = {
            lookup: [],
            vehicleDetailsSetCorrectButtonState: (_a = _this.props.interaction.uistate) === null || _a === void 0 ? void 0 : _a.isVehicleDetailsSetCorrectly,
            vrn: (_b = car.vehicleRegistrationNumber) !== null && _b !== void 0 ? _b : "",
            isVRNValid: _this.validateVRN(car.vehicleRegistrationNumber),
            showVRNInput: false
        };
        _this.handleOnChangeEvent = _this.handleOnChangeEvent.bind(_this);
        _this.handleVRNInput = _this.handleVRNInput.bind(_this);
        _this.setShowVRNInput = _this.setShowVRNInput.bind(_this);
        return _this;
    }
    DisplayAnnualCarDetailsWidget.prototype.componentDidMount = function () {
        this.fetchLookupValues("vehicleTransmission");
        this.fetchLookupValues("vehicleFuelType");
    };
    DisplayAnnualCarDetailsWidget.prototype.render = function () {
        return (React.createElement(React.Fragment, null, this.renderCarDetails()));
    };
    DisplayAnnualCarDetailsWidget.prototype.handleOnChangeEvent = function (event) {
        this.setState({
            vehicleDetailsSetCorrectButtonState: true
        });
        this.props.onStateChange(this.props.question.interactionField, true);
        if (event.target.value === "false") {
            this.navigateToEditCarDetailsPage();
        }
    };
    DisplayAnnualCarDetailsWidget.prototype.handleVRNInput = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var vrn, isValid;
            return __generator(this, function (_a) {
                vrn = event.target.value.trim().toUpperCase();
                isValid = this.validateVRN(vrn);
                this.setState({ isVRNValid: isValid });
                this.setState({ vrn: vrn });
                this.props.onStateChange(this.props.question.interactionField, isValid);
                if (isValid) {
                    this.props.onStateChange("vehicles[0].registrationNumber", vrn);
                }
                else {
                    this.props.onStateChange("vehicles[0].registrationNumber", null);
                }
                return [2 /*return*/];
            });
        });
    };
    DisplayAnnualCarDetailsWidget.prototype.fetchLookupValues = function (lookupName) {
        var _this = this;
        this.lookupService.fetchLookupValues(lookupName, "en-UK").subscribe(function (lookupValues) {
            _this.state.lookup[lookupName] = lookupValues;
            _this.setState({ lookup: _this.state.lookup });
        }, function () {
            throw new Error("Error: failed to fetch lookup values for '".concat(lookupName, "' lookup"));
        });
    };
    DisplayAnnualCarDetailsWidget.prototype.validateVRN = function (vrn) {
        return services_1.VEHICLE_REG_NUMBER_REGEX.test(vrn);
    };
    DisplayAnnualCarDetailsWidget.prototype.resolveLookupValue = function (lookupName, lookupId) {
        if (!lookupId || !this.state.lookup || !this.state.lookup[lookupName]) {
            return "";
        }
        var listItem = this.state.lookup[lookupName].find(function (listItem) { return "".concat(listItem.id) === "".concat(lookupId); });
        if (!listItem) {
            throw new Error("Error: no item with id '".concat(lookupId, "' found in lookup '").concat(lookupName, "'"));
        }
        return listItem.value;
    };
    DisplayAnnualCarDetailsWidget.prototype.setShowVRNInput = function () {
        this.setState({
            showVRNInput: true
        });
    };
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.LookupService),
        __metadata("design:type", Object)
    ], DisplayAnnualCarDetailsWidget.prototype, "lookupService", void 0);
    return DisplayAnnualCarDetailsWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=DisplayAnnualCarDetailsWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/DisplayAnnualCarDetailsWidget.js
// module id = 3209
// module chunks = 0